import { motion } from "framer-motion";

export default function SectionHeading({ overline, title, description, testid }) {
  return (
    <div className="max-w-3xl" data-testid={testid}>
      <motion.p
        initial={{ opacity: 0, y: 16 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.6 }}
        className="text-xs uppercase tracking-[0.3em] text-[#C5A059] font-mono mb-4"
      >
        {overline}
      </motion.p>
      <motion.h2
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.7, delay: 0.1 }}
        className="font-display text-2xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-[#F4EBE1]"
      >
        {title}
      </motion.h2>
      {description && (
        <motion.p
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="mt-5 text-sm sm:text-base text-[#C0B9B0] leading-relaxed"
        >
          {description}
        </motion.p>
      )}
    </div>
  );
}
